import Enum from '/@/modules/core/app/helpers/Enum';

export class EstateTaxFormMetaType extends Enum {
  static ESTATE_TAX_FORM_CANADA_META: string = 'EstateTaxFormCanadaMeta';

  static ESTATE_TAX_FORM_US_META: string = 'EstateTaxFormUsMeta';
}
